import styled from 'styled-components';

import { Translate } from '@dreryk/react-common';
import { InfoTooltip, Text } from '@dreryk/react-components';

import { medicalDevicesTranslationKeys } from '../../../translations';

const StyledQuestionMarkIcon = styled.div`
   border-radius: 50%;
   width: 20px;
   height: 20px;
   background-color: ${(props) => props.theme.primary};
   display: flex;
   justify-content: center;
   align-items: center;
`;
StyledQuestionMarkIcon.displayName = 'StyledQuestionMarkIcon';

const StyledNestedList = styled.ul`
   list-style: lower-latin;
`;
StyledNestedList.displayName = 'StyledNestedList';

const ShorteningDeviceUseTimeSpanTooltipContent = (): JSX.Element => {
   return (
      <Text testId={'shorteningDeviceUseTimeSpan'}>
         <Translate>{medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip.prefixText}</Translate>
         <ol>
            <li>
               <Translate>
                  {medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip.firstListItem}
               </Translate>
            </li>
            <li>
               <Translate>
                  {medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip.secondListItem}
               </Translate>
               <StyledNestedList>
                  <li>
                     <Translate>
                        {
                           medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip
                              .secondListItemFirstNest
                        }
                     </Translate>
                  </li>
                  <li>
                     <Translate>
                        {
                           medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip
                              .secondListItemSecondNest
                        }
                     </Translate>
                  </li>
                  <li>
                     <Translate>
                        {
                           medicalDevicesTranslationKeys.fields.shorteningDeviceUseTimeSpanTooltip
                              .secondListItemThirdNest
                        }
                     </Translate>
                  </li>
               </StyledNestedList>
            </li>
         </ol>
      </Text>
   );
};

export const ShorteningDeviceUseTimeSpanJustificationTooltip = (): JSX.Element => {
   return (
      <InfoTooltip testId={'shorteningDeviceUseTimeSpan'} content={<ShorteningDeviceUseTimeSpanTooltipContent />} />
   );
};
